import React from "react";
import { Badge } from "reactstrap";
import { Link } from "react-router-dom";
import { getPlanBadgeConfigForPlan } from "../views/stripeSubscription/planUtils";
import {
  topbarBadgeClassName,
  topbarBadgeLinkStyle,
} from "../layouts/layout-components/header/topbarBadgeStyles";

const SubscriptionPlanBadge = ({
  planName,
  plans = [],
  linkTo,
  className = "",
  topbar = false,
}) => {
  if (!planName) {
    return null;
  }

  const config = getPlanBadgeConfigForPlan(planName, plans);
  if (!config) {
    return null;
  }

  const badgeClassName = topbar
    ? topbarBadgeClassName
    : `p-2 d-flex align-items-center ${className}`.trim();

  const badge = (
    <Badge
      className={badgeClassName}
      style={{
        backgroundColor: config.bg,
        color: config.text,
      }}
    >
      <span style={{ fontSize: "18px", fontWeight: "bold" }}>{planName}</span>
      {config.icon && (
        <i
          className={`ml-2 mdi ${config.icon}`}
          style={{ fontSize: "18px", lineHeight: 1 }}
          aria-hidden="true"
        />
      )}
    </Badge>
  );

  if (linkTo) {
    return (
      <Link
        to={linkTo}
        style={topbar ? topbarBadgeLinkStyle : { textDecoration: "none" }}
      >
        {badge}
      </Link>
    );
  }

  return badge;
};

export default SubscriptionPlanBadge;
